/* Auto-generated literal translation map for UI strings */

export type SupportedLanguage = 'pt-BR' | 'en' | 'es';

export const literalTranslations: Record<string, Partial<Record<SupportedLanguage, string>>> = {
  "Seleção de Compressores Elgin": {
    "en": "Elgin Compressor Selection",
    "es": "Selección de Compresores Elgin"
  },
  "Seleção de Compressores Semi Hermeticos": {
    "en": "Compressor Selection Semi Hermetic",
    "es": "Selección de Compresores Semi Herméticos"
  },
  "Selecione": {
    "en": "Select",
    "es": "Seleccionar"
  },
  "Buscando...": {
    "en": "Searching...",
    "es": "Buscando..."
  },
  "Desabilitado": {
    "en": "Disabled",
    "es": "Deshabilitado"
  },
  "Fechar": {
    "en": "Close",
    "es": "Cerrar"
  },
  "Modo de busca": {
    "en": "Search mode",
    "es": "Modo de búsqueda"
  },
  "Pesquisar modelo...": {
    "en": "Search model...",
    "es": "Buscar modelo..."
  },
  "Filtrar por aplicação": {
    "en": "Filter by application",
    "es": "Filtrar por aplicación"
  },
  "Unidade de capacidade": {
    "en": "Capacity unit",
    "es": "Unidad de capacidad"
  },
  "Frequência": {
    "en": "Frequency",
    "es": "Frecuencia"
  },
  "Tensão": {
    "en": "Voltage",
    "es": "Tensión"
  },
  "Por modelo": {
    "en": "By model",
    "es": "Por modelo"
  },
  "Por capacidade": {
    "en": "By capacity",
    "es": "Por capacidad"
  },
  "Temperatura de condensação": {
    "en": "Condensing temperature",
    "es": "Temperatura de condensación"
  },
  "Temperatura de evaporação": {
    "en": "Evaporating temperature",
    "es": "Temperatura de evaporación"
  },
  "Superaquecimento total": {
    "en": "Total superheat",
    "es": "Sobrecalentamiento total"
  },
  "Superaquecimento útil": {
    "en": "Useful superheat",
    "es": "Sobrecalentamiento útil"
  },
  "Curva de saturação": {
    "en": "Saturation curve",
    "es": "Curva de saturación"
  },
  "Ciclo de refrigeração": {
    "en": "Refrigeration cycle",
    "es": "Ciclo de refrigeración"
  },
  "Execute o cálculo para visualizar o diagrama P-h.": {
    "en": "Run the calculation to view the P-h diagram.",
    "es": "Ejecute el cálculo para ver el diagrama P-h."
  },
  "Gerando diagrama P-h...": {
    "en": "Generating P-h diagram...",
    "es": "Generando diagrama P-h..."
  },
  "Gerando diagrama...": {
    "en": "Generating diagram...",
    "es": "Generando diagrama..."
  },
  "Sem dados": {
    "en": "No data",
    "es": "Sin datos"
  },
  "Zoom ciclo": {
    "en": "Cycle zoom",
    "es": "Zoom del ciclo"
  },
  "Reset zoom": {
    "en": "Reset zoom",
    "es": "Restablecer zoom"
  },
  "Erro ao recuperar compressores.": {
    "en": "Failed to retrieve compressors.",
    "es": "Error al recuperar los compresores."
  },
  "Erro no cálculo do rendimento volumétrico": {
    "en": "Error calculating volumetric efficiency",
    "es": "Error al calcular la eficiencia volumétrica"
  },
  "Modelo abaixo mais próximo": {
    "en": "Closest model below",
    "es": "Modelo más cercano por debajo"
  },
  "Modelo acima mais próximo": {
    "en": "Closest model above",
    "es": "Modelo más cercano por encima"
  },
  "Nenhum modelo encontrado.": {
    "en": "No models found.",
    "es": "No se encontraron modelos."
  },
  "Informe evaporação, condensação e refrigerante para visualizar o envelope.": {
    "en": "Specify evaporation, condensation, and refrigerant to view the envelope.",
    "es": "Especifique la evaporación, condensación y refrigerante para ver el envelope."
  },
  "Gerando matriz...": {
    "en": "Generating matrix...",
    "es": "Generando matriz..."
  },
    "Nenhuma linha gerada ainda.": {
    "en": "No rows generated yet.",
    "es": "Aún no se han generado filas."
  },
  "Engenharia de Aplicação | Versão 3.9": {
    "en": "Application Engineering | Version 3.9",
    "es": "Ingeniería de Aplicaciones | Versión 3.9"
  },
  "Gerar PDF": {
    "en": "Generate PDF",
    "es": "Generar PDF"
  },
  "Gerar Excel": {
    "en": "Generate Excel",
    "es": "Generar Excel"
  },
  "Matriz de Resultados": {
    "en": "Results Matrix",
    "es": "Matriz de Resultados"
  },
  "Calcular": {
    "en": "Calculate",
    "es": "Calcular"
  },
  "Buscar Modelos": {
    "en": "Find Models",
    "es": "Buscar Modelos"
  },
  "Use 'Buscar Modelos'": {
    "en": "Use 'Find Models'",
    "es": "Use 'Buscar Modelos'"
  },
  "Selecionar este Modelo": {
    "en": "Select this Model",
    "es": "Seleccionar este Modelo"
  },
  "Dados de Entrada": {
    "en": "Input Data",
    "es": "Datos de Entrada"
  },
  "Por Modelo": {
    "en": "By Model",
    "es": "Por Modelo"
  },
  "Por Capacidade": {
    "en": "By Capacity",
    "es": "Por Capacidad"
  },
  "Modelo": {
    "en": "Model",
    "es": "Modelo"
  },
  "Frequência (Hz)": {
    "en": "Frequency (Hz)",
    "es": "Frecuencia (Hz)"
  },
  "Tensão (V)": {
    "en": "Voltage (V)",
    "es": "Tensión (V)"
  },
  "Capacidade Necessária (kW)": {
    "en": "Required Capacity (kW)",
    "es": "Capacidad Requerida (kW)"
  },
  "Refrigerante": {
    "en": "Refrigerant",
    "es": "Refrigerante"
  },
  "Temperatura de Condensação": {
    "en": "Condensing Temperature",
    "es": "Temperatura de Condensación"
  },
  "Condensação": {
    "en": "Condensing",
    "es": "Condensación"
  },
  "Temperatura de Evaporação": {
    "en": "Evaporating Temperature",
    "es": "Temperatura de Evaporación"
  },
  "Evaporação": {
    "en": "Evaporating",
    "es": "Evaporación"
  },
  "Superaquecimento Total": {
    "en": "Total Superheat",
    "es": "Sobrecalentamiento Total"
  },
  "Utilizar Superaquecimento Útil": {
    "en": "Use Useful Superheat",
    "es": "Utilizar Sobrecalentamiento Útil"
  },
  "Superaquecimento Útil": {
    "en": "Useful Superheat",
    "es": "Sobrecalentamiento Útil"
  },
  "Sub-resfriamento": {
    "en": "Subcooling",
    "es": "Subenfriamiento"
  },
  "Resultados": {
    "en": "Results",
    "es": "Resultados"
  },
  "Geral": {
    "en": "General",
    "es": "General"
  },
  "Dados Físicos": {
    "en": "Physical Data",
    "es": "Datos Físicos"
  },
  "Performance": {
    "en": "Performance",
    "es": "Rendimiento"
  },
  "Capacidade de Refrigeração": {
    "en": "Cooling Capacity",
    "es": "Capacidad de Refrigeración"
  },
  "Capacidade de Refrigeração EN12900": {
    "en": "Capacity EN12900",
    "es": "Capacidad EN12900"
  },
  "Calor Rejeitado": {
    "en": "Heat Rejection",
    "es": "Calor Rechazado"
  },
  "COP": {
    "en": "COP",
    "es": "COP"
  },
  "COP EN12900": {
    "en": "COP EN12900",
    "es": "COP EN12900"
  },
  "Dados Gerais": {
    "en": "General Data",
    "es": "Datos Generales"
  },
  "Potência Consumida": {
    "en": "Power Consumed",
    "es": "Potencia Consumida"
  },
  "Corrente": {
    "en": "Current",
    "es": "Corriente"
  },
  "Vazão Mássica": {
    "en": "Mass Flow",
    "es": "Caudal Másico"
  },
  "Deslocamento Nominal": {
    "en": "Nominal Displacement",
    "es": "Desplazamiento Nominal"
  },
  "Dados Ciclo": {
    "en": "Cycle Data",
    "es": "Datos del Ciclo"
  },
  "Pressão de Descarga": {
    "en": "Discharge Pressure",
    "es": "Presión de Descarga"
  },
  "Pressão de Sucção": {
    "en": "Suction Pressure",
    "es": "Presión de Succión"
  },
  "Temperatura de Descarga": {
    "en": "Discharge Temperature",
    "es": "Temperatura de Descarga"
  },
  "Dados do Compressor": {
    "en": "Compressor Data",
    "es": "Datos del Compresor"
  },
  "Dados Técnicos": {
    "en": "Technical Data",
    "es": "Datos Técnicos"
  },
  "Dimensões": {
    "en": "Dimensions",
    "es": "Dimensiones"
  },
  "Marca": {
    "en": "Brand",
    "es": "Marca"
  },
  "Tipo": {
    "en": "Type",
    "es": "Tipo"
  },
  "HP": {
    "en": "HP",
    "es": "HP"
  },
  "Aplicação": {
    "en": "Application",
    "es": "Aplicación"
  },
  "Cilindros": {
    "en": "Cylinders",
    "es": "Cilindros"
  },
  "Peso (kg)": {
    "en": "Weight (kg)",
    "es": "Peso (kg)"
  },
  "Sucção (in)": {
    "en": "Suction (in)",
    "es": "Succión (in)"
  },
  "Descarga (in)": {
    "en": "Discharge (in)",
    "es": "Descarga (in)"
  },
  "Óleo": {
    "en": "Oil",
    "es": "Aceite"
  },
  "Carga de Óleo (L)": {
    "en": "Oil Charge (L)",
    "es": "Carga de Aceite (L)"
  },
  "Pressão Máxima LP (bar)": {
    "en": "Max Pressure LP (bar)",
    "es": "Presión Máxima LP (bar)"
  },
  "Pressão Máxima HP (bar)": {
    "en": "Max Pressure HP (bar)",
    "es": "Presión Máxima HP (bar)"
  },
  "RLA (A)": {
    "en": "RLA (A)",
    "es": "RLA (A)"
  },
  "MCC (A)": {
    "en": "MCC (A)",
    "es": "MCC (A)"
  },
  "LRA (A)": {
    "en": "LRA (A)",
    "es": "LRA (A)"
  },
  "Capacitor de Partida": {
    "en": "Start Capacitor",
    "es": "Capacitor de Arranque"
  },
  "Capacitor de Trabalho": {
    "en": "Run Capacitor",
    "es": "Capacitor de Marcha"
  },
  "Relé": {
    "en": "Relay",
    "es": "Relé"
  },
  "Herméticos": {
    "en": "Hermetic Compressors",
    "es": "Compresores Herméticos"
  },
  "Semi-Herméticos": {
    "en": "Semi-Hermetic Compressors",
    "es": "Compresores Semiherméticos"
  },
  "Fechamento Elétrico": {
    "en": "Electrical Wiring",
    "es": "Conexión Eléctrica"
  },
  "IP": {
    "en": "IP",
    "es": "IP"
  },
  "A": {
    "en": "A",
    "es": "A"
  },
  "B": {
    "en": "B",
    "es": "B"
  },
  "C": {
    "en": "C",
    "es": "C"
  },
  "D": {
    "en": "D",
    "es": "D"
  },
  "Selecione um compressor para ver os dados.": {
    "en": "Select a compressor to see its data.",
    "es": "Seleccione un compresor para ver sus datos."
  },
  "Temperatura": {
    "en": "Temperature",
    "es": "Temperatura"
  },
  "Idioma": {
    "en": "Language",
    "es": "Idioma"
  },
  "Diagrama P-h": {
    "en": "P-h Diagram",
    "es": "Diagrama P-h"
  },
  "Envelope de Operação": {
    "en": "Operating Envelope",
    "es": "Envolvente de Operación"
  },
  "Ponto de Operação": {
    "en": "Operating Point",
    "es": "Punto de Operación"
  },
  "Curva de Saturação": {
    "en": "Saturation Curve",
    "es": "Curva de Saturación"
  },
  "Ciclo de Refrigeração": {
    "en": "Refrigeration Cycle",
    "es": "Ciclo de Refrigeración"
  },
  "Pressão": {
    "en": "Pressure",
    "es": "Presión"
  },
  "Entalpia": {
    "en": "Enthalpy",
    "es": "Entalpía"
  },
  "Visualização Ampliada - Diagrama P-h": {
    "en": "Enlarged View - P-h Diagram",
    "es": "Vista Ampliada - Diagrama P-h"
  },
  "Visualização Ampliada - Envelope de Operação": {
    "en": "Enlarged View - Operating Envelope",
    "es": "Vista Ampliada - Envolvente de Operación"
  },
  "AVISO: Ponto de operação FORA do envelope!": {
    "en": "WARNING: Operating point OUTSIDE envelope!",
    "es": "AVISO: ¡Punto de operación FUERA del envolvente!"
  },
  "Envelope não definido para este fluido.": {
    "en": "Envelope not defined for this fluid.",
    "es": "Envolvente no definido para este fluido."
  },
  "Operação padrão dentro do envelope.": {
    "en": "Standard operation within the envelope.",
    "es": "Operación estándar dentro del envolvente."
  },
  "Atenção: Temperatura do gás de sucção limitada com superaquecimento <11K.": {
  "en": "Warning: Suction gas temperature limited with superheat <11K.",
  "es": "Atención: Temperatura del gas de succión limitada con sobrecalentamiento <11K."
  },
  "Atenção: Superaquecimento = 11K.": {
    "en": "Warning: Superheat = 11K.",
    "es": "Atención: Sobrecalentamiento = 11K."
  },
  "Atenção: Superaquecimento <= 11K.": {
    "en": "Warning: Superheat <= 11K.",
    "es": "Atención: Sobrecalentamiento <= 11K."
  },
  "Atenção: Requer resfriamento adicional.": {
    "en": "Warning: Additional cooling is required.",
    "es": "Atención: Se requiere refrigeración adicional."
  },
  "Erro": {
    "en": "Error",
    "es": "Error"
  },
  "Aviso": {
    "en": "Warning",
    "es": "Advertencia"
  },
  "Informação": {
    "en": "Information",
    "es": "Información"
  },
  "Sucesso": {
    "en": "Success",
    "es": "Éxito"
  },
  "Ocorreu um erro ao carregar o arquivo Excel": {
    "en": "An error occurred while loading the Excel file",
    "es": "Ocurrió un error al cargar el archivo Excel"
  },
  "Nenhum compressor selecionado.": {
    "en": "No compressor selected.",
    "es": "Ningún compresor seleccionado."
  },
  "Por favor, verifique os dados de entrada.": {
    "en": "Please check the input data.",
    "es": "Por favor, verifique los datos de entrada."
  },
  "O ponto de operação está fora do envelope permitido.": {
    "en": "The operating point is outside the allowed envelope.",
    "es": "El punto de operación está fuera del envolvente permitido."
  },
  "Relatório PDF gerado com sucesso!": {
    "en": "PDF report generated successfully!",
    "es": "¡Informe PDF generado con éxito!"
  },
  "Relatório Excel gerado com sucesso!": {
    "en": "Excel report generated successfully!",
    "es": "¡Informe Excel generado con éxito!"
  },
  "Erro ao Gerar PDF": {
    "en": "Error Generating PDF",
    "es": "Error al Generar PDF"
  },
  "Erro ao Gerar Excel": {
    "en": "Error Generating Excel",
    "es": "Error al Generar Excel"
  },
  "Ocorreu um erro inesperado no cálculo": {
    "en": "An unexpected calculation error occurred",
    "es": "Ocurrió un error de cálculo inesperado"
  },
  "Valor inválido: '{value}' não é um número.": {
    "en": "Invalid value: '{value}' is not a number.",
    "es": "Valor inválido: '{value}' no es un número."
  },
  "PASSO": {
    "en": "STEP",
    "es": "PASO"
  },
  "Gerar Matriz": {
    "en": "Generate Matrix",
    "es": "Generar Matriz"
  },
  "Gerar Matriz (EN12900)": {
    "en": "Generate Matrix (EN12900)",
    "es": "Generar Matriz (EN12900)"
  },
  "Plotar Gráficos": {
    "en": "Plot Graphs",
    "es": "Trazar Gráficos"
  },
  "Exportar Excel": {
    "en": "Export Excel",
    "es": "Exportar Excel"
  },
  "Temp. Evaporação": {
    "en": "Evap. Temperature",
    "es": "Temp. Evaporación"
  },
  "Temp. Condensação": {
    "en": "Cond. Temperature",
    "es": "Temp. Condensación"
  },
  "T. Evap": {
    "en": "Evap. T",
    "es": "T. Evap"
  },
  "T. Cond": {
    "en": "Cond. T",
    "es": "T. Cond"
  },
  "Capacidade": {
    "en": "Capacity",
    "es": "Capacidad"
  },
  "Potência (kW)": {
    "en": "Power (kW)",
    "es": "Potencia (kW)"
  },
  "Calor Rej.": {
    "en": "Heat Rej.",
    "es": "Calor Rech."
  },
  "Corrente (A)": {
    "en": "Current (A)",
    "es": "Corriente (A)"
  },
  "T. Descarga": {
    "en": "Discharge T",
    "es": "T. Descarga"
  },
  "{count} pontos válidos calculados.": {
    "en": "{count} valid points calculated.",
    "es": "{count} puntos válidos calculados."
  },
  "{count} pontos válidos (EN12900) calculados.": {
    "en": "{count} valid points (EN12900) calculated.",
    "es": "{count} puntos válidos (EN12900) calculados."
  },
  "Nenhum resultado válido encontrado no envelope.": {
    "en": "No valid results found within the envelope.",
    "es": "No se encontraron resultados válidos en el envolvente."
  },
  "Seleção de Compressor por Capacidade": {
    "en": "Compressor Selection by Capacity",
    "es": "Selección de Compresor por Capacidad"
  },
  "Capacidade Necessária": {
    "en": "Required Capacity",
    "es": "Capacidad Requerida"
  },
  "Filtrar por Aplicação": {
    "en": "Filter by Application",
    "es": "Filtrar por Aplicación"
  },
  "Todas": {
    "en": "All",
    "es": "Todas"
  },
  "Nenhum modelo encontrado com o filtro.": {
    "en": "No models found with this filter.",
    "es": "No se encontraron modelos con este filtro."
  },
  "Modelo Imediatamente Inferior": {
    "en": "Immediately Lower Model",
    "es": "Modelo Inmediatamente Inferior"
  },
  "Modelo Imediatamente Superior": {
    "en": "Immediately Higher Model",
    "es": "Modelo Inmediatamente Superior"
  },
  "Nenhum modelo com capacidade inferior.": {
    "en": "No model with lower capacity found.",
    "es": "No se encontró ningún modelo con capacidad inferior."
  },
  "Nenhum modelo com capacidade superior.": {
    "en": "No model with higher capacity found.",
    "es": "No se encontró ningún modelo con capacidad superior."
  },
  "Nenhum compressor encontrado para a frequência e tensão selecionadas.": {
    "en": "No compressors found for the selected frequency and voltage.",
    "es": "No se encontraron compresores para la frecuencia y tensión seleccionadas."
  },
  "Nenhum compressor compatível encontrado para as condições informadas.": {
    "en": "No compatible compressors found for the given conditions.",
    "es": "No se encontraron compresores compatibles para las condiciones dadas."
  },
  "Gráficos de Performance da Matriz": {
    "en": "Matrix Performance Graphs",
    "es": "Gráficos de Rendimiento de Matriz"
  },
  "Curvas de Performance": {
    "en": "Performance Curves",
    "es": "Curvas de Rendimiento"
  },
  "Legenda": {
    "en": "Legend",
    "es": "Leyenda"
  },
  "Projetos": {
    "en": "Projects",
    "es": "Proyectos"
  },
  "Produtos": {
    "en": "Products",
    "es": "Productos"
  },
  "Sair": {
    "en": "Logout",
    "es": "Salir"
  },
  "Português": {
    "en": "Portuguese",
    "es": "Portugués"
  },
  "English": {
    "en": "English",
    "es": "Inglés"
  },
  "Español": {
    "en": "Spanish",
    "es": "Español"
  },
  "pt-BR": {
    "en": "pt-BR",
    "es": "pt-BR"
  },
  "en": {
    "en": "en",
    "es": "en"
  },
  "es": {
    "en": "es",
    "es": "es"
  }
};

export const translateLiteral = (
  key: string,
  language: SupportedLanguage = 'pt-BR'
) => {
  if (language === 'pt-BR') return key;
  return literalTranslations[key]?.[language] || key;
};
